module.exports = __webpack_public_path__ + "img/icon-warning-ice-yellow.d00a04be.svg";